import dayjs from 'dayjs';

export const DEFAULT_DATE = {
  timeType: 'static',
  timeDimension: 'day',
  startTime: dayjs().subtract(7, 'day').format('YYYYMMDD'),
  endTime: dayjs().subtract(1, 'day').format('YYYYMMDD'),
};

export const DEFAULT_GROUP_PROPERTY_TYPE_OPTIONS = [
  { value: -1, label: '总体' },
  { value: 1, label: '事件属性' },
  { value: 2, label: '用户属性' },
];

export const DEFAULT_TIME_UNIT_OPTIONS = [
  { value: 'day', label: '按日' },
  { value: 'week', label: '按周' },
  { value: 'month', label: '按月' },
  { value: 'hour', label: '按小时' },
];

export const DEFAULT_CHART_TYPE_OPTIONS = [
  { value: 'group', label: '区间' },
  { value: 'trend', label: '趋势' },
];

export const DEFAULT_CHART_SHOW_TYPE_OPTIONS = [
  { value: 'line', label: '折线图' },
  { value: 'ratioLine', label: '百分比图' },
];

export const DISTRIBUTION_REGION_TYPE_OPTION = [
  { value: 1, label: '快捷区间' },
  { value: 2, label: '自定义区间' },
];

export const DISTRIBUTION_GROUP_OPTION = [
  { value: -1, label: '智能分组' },
  { value: 5, label: '5等分' },
  { value: 10, label: '10等分' },
  { value: 15, label: '15等分' },
  { value: 0, label: '自定义步长' },
];

export const CHART_TYPE_OPTION = [
  { value: 'group', label: '区间' },
  { value: 'trend', label: '趋势' },
];

export const DISTRIBUTION_REGION_TYPE_ENUM = {
  DEFAULT: 1,
  CUSTOM: 2,
};

export const DISTRIBUTION_REGION_GROUP_ENUM = {
  AUTO: -1,
  CUSTOM: 0,
  FIVE: 5,
  TEN: 10,
  FIFTEEN: 15,
};
